import s from './style.css';
import Container from 'components/Container';
import Logo from 'components/Logo';

const objToHash = obj =>
	Object.keys(obj)
		.map(key => `${key}=${encodeURIComponent(obj[key])}`)
		.join('&');

const tweetParams = {
	url: URL,
	text:
		'Would you ever date a colleague? And which job offers the best chance of a date? Discover the secrets of the UK’s workplace romances with @totaljobsuk.'
};

const fbParams = {
	u: URL
};

const Header = () => (
	<div className={s.root}>
		<Container snug>
			<div className={s.logo}>
				<Logo />
			</div>
			<div className={s.links}>
				<a
					className={s.shareLink}
					href={`https://twitter.com/share?${objToHash(tweetParams)}`}
					target="_blank"
					rel="noopener"
				>
					<svg
						width={15}
						height={15}
						viewBox={'0 0 25 25'}
						fill={'currentColor'}
					>
						<title>Share on Twitter</title>
						<path d="M22.05 5.17a5.38 5.38 0 0 0 2.26-3 9.88 9.88 0 0 1-3.26 1.31 5 5 0 0 0-3.74-1.7 5.27 5.27 0 0 0-5.13 5.4 5.61 5.61 0 0 0 .13 1.24A14.33 14.33 0 0 1 1.74 2.77a5.67 5.67 0 0 0-.69 2.73A5.48 5.48 0 0 0 3.33 10 4.94 4.94 0 0 1 1 9.32v.07a5.34 5.34 0 0 0 4.12 5.3 4.64 4.64 0 0 1-1.35.19 5.15 5.15 0 0 1-1-.09 5.16 5.16 0 0 0 4.79 3.75 9.89 9.89 0 0 1-6.37 2.32A8.24 8.24 0 0 1 0 20.78a14 14 0 0 0 7.86 2.43c9.44 0 14.59-8.24 14.59-15.39v-.7A10.71 10.71 0 0 0 25 4.32a9.83 9.83 0 0 1-2.95.85z" />
					</svg>
				</a>

				<a
					className={s.shareLink}
					href={`https://www.facebook.com/sharer/sharer.php?${objToHash(
						fbParams
					)}`}
					target="_blank"
					rel="noopener"
				>
					<svg
						width={15}
						height={15}
						viewBox={'0 0 25 25'}
						fill={'currentColor'}
					>
						<title>Share on Facebook</title>
						<path d="M14.47 25h-5.3V12.5H6.52V8.19h2.65V5.6c0-3.51 1.5-5.6 5.75-5.6h3.53v4.31h-2.21c-1.65 0-1.76.6-1.76 1.72v2.16h4L18 12.5h-3.53V25z" />
					</svg>
				</a>
			</div>
		</Container>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/Header/index.js